module.exports = require('stream');



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/lib/internal/streams/stream.js
// module id = 395
// module chunks = 0